import { render, staticRenderFns } from "./DocumentAndPdfTypeSlot.vue?vue&type=template&id=12cca93a&scoped=true"
import script from "./DocumentAndPdfTypeSlot.vue?vue&type=script&lang=ts"
export * from "./DocumentAndPdfTypeSlot.vue?vue&type=script&lang=ts"
import style0 from "./DocumentAndPdfTypeSlot.vue?vue&type=style&index=0&id=12cca93a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cca93a",
  null
  
)

export default component.exports